export default __webpack_public_path__ + "static/1255-8db23127592e65e8a629d43dec1d9711.gif";